import React from 'react';
import { signOut } from 'firebase/auth';
import { auth, rolesConfig } from '../firebase'; // Importamos la configuración desde firebase.js
import { Home, FilePlus, Search, CreditCard, FileText, Settings, LogOut, Users, X } from 'lucide-react';

const Sidebar = ({ userRole, activePage, setActivePage, isOpen, toggleSidebar }) => {
     const handleLogout = async () => {
        try {
            await signOut(auth);
        } catch (error) {
            console.error("Error al cerrar sesión:", error);
        }
    };

    const menuItems = [
        { id: 'dashboard', label: 'Inicio', icon: Home },
        { id: 'registrar', label: 'Registrar Multa', icon: FilePlus },
        { id: 'buscar', label: 'Buscar Multas', icon: Search },
        { id: 'pagar', label: 'Pagar Multa', icon: CreditCard },
        { id: 'reportes', label: 'Reportes', icon: FileText },
        { id: 'infracciones', label: 'Tipos de Infracción', icon: Settings },
        { id: 'usuarios', label: 'Gestionar Usuarios', icon: Users },
    ];

    const allowedMenuItems = menuItems.filter(item => rolesConfig[userRole]?.permissions.includes(item.id));

    const sidebarContent = (
        <div className="flex flex-col h-full">
             <div className="p-4 border-b border-gray-700 flex justify-between items-center">
                <div>
                    <h2 className="text-xl font-bold">Sistema de Multas</h2>
                    <p className="text-sm text-gray-400">Rol: {rolesConfig[userRole]?.name}</p>
                </div>
                <button onClick={toggleSidebar} className="sm:hidden text-gray-400 hover:text-white">
                    <X size={24} />
                </button>
            </div>
            <nav className="flex-1 px-2 py-4 space-y-2">
                {allowedMenuItems.map(item => (
                    <a
                        key={item.id}
                        href="#"
                        onClick={(e) => { 
                            e.preventDefault(); 
                            setActivePage(item.id);
                            if (isOpen) toggleSidebar(); // Cierra el menú en móvil al seleccionar
                        }}
                        className={`flex items-center px-4 py-2.5 rounded-md transition-colors duration-200 ${activePage === item.id ? 'bg-gray-700' : 'hover:bg-gray-700'}`}
                    >
                        <item.icon className="w-5 h-5 mr-3" />
                        {item.label}
                    </a>
                ))}
            </nav>
            <div className="p-2 border-t border-gray-700">
                <a
                    href="#"
                    onClick={handleLogout}
                    className="flex items-center w-full px-4 py-2.5 rounded-md hover:bg-red-500 transition-colors duration-200"
                >
                    <LogOut className="w-5 h-5 mr-3" />
                    Cerrar Sesión
                </a>
            </div>
        </div>
    );

    return (
        <>
            {/* Sidebar para Escritorio */}
            <aside className="w-64 bg-gray-800 text-white flex-col hidden sm:flex">
                {sidebarContent}
            </aside>

            {/* Sidebar para Móvil (Overlay) */}
            <div 
                className={`fixed inset-0 bg-black bg-opacity-50 z-20 sm:hidden transition-opacity ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
                onClick={toggleSidebar}
            ></div>
            <aside 
                className={`fixed inset-y-0 left-0 w-64 bg-gray-800 text-white z-30 transform transition-transform sm:hidden ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}
            >
                {sidebarContent}
            </aside>
        </>
    );
};

export default Sidebar;